<template>
	<v-row>
		<v-fade-transition mode="out-in">
			<result-revealer
				v-if="mode === modes.roulette"
				:result="result"
				:resources="{
					pick2Img: require('assets/static/img/picks/prestigelotto/pick2.png'),
					pick3Img: require('assets/static/img/picks/prestigelotto/pick3.png'),
					pick4Img: require('assets/static/img/picks/prestigelotto/pick4.png'),
					pick5Img: require('assets/static/img/picks/prestigelotto/pick5.png')
				}"
				@finish="handleResultsDone"
			>
				<template v-slot:logo>
					<v-img
						:src="require('../../../../assets/img/quicklotto/logo.png')"
						contain
						width="400"
						alt="logo"
					/>
				</template>
			</result-revealer>
			<winning-numbers
				v-else-if="mode === modes.winningNumbers"
				:result="result"
			></winning-numbers>
		</v-fade-transition>
	</v-row>
</template>

<script>
import WinningNumbers from './WinningNumbers.vue';
import ResultRevealer from '@homepage/components/common/ResultRevealer.vue';
import RouletteSpinner from '@homepage/components/common/RouletteSpinner.vue';
import { Howl } from 'howler';
import song from 'assets/static/sounds/piano_instrumental.mp3';

const modes = {
	roulette: 1,
	winningNumbers: 2
};

export default {
	name: 'Roulette',
	props: {
		result: {
			type: Object,
			required: true
		}
	},
	created() {
		this.sound.play();
	},
	destroyed() {
		this.sound.stop();
	},
	components: {
		WinningNumbers,
		ResultRevealer,
	},
	data() {
		return {
			modes,
			mode: modes.roulette,
			sound: new Howl({
				src: song,
				duration: 4,
				autoplay: false,
				volume: 0.3,
				loop: true
			}) //,
			//mockedResult: {
			// 	numbers: [
			// 		{
			// 			playType: {
			// 				id: 4,
			// 				name: 'Pick 2'
			// 			},
			// 			digits: '23'
			// 		},
			// 		{
			// 			playType: {
			// 				id: 5,
			// 				name: 'Cash 3'
			// 			},
			// 			digits: '234'
			// 		},
			// 		{
			// 			playType: {
			// 				id: 6,
			// 				name: 'Play 4'
			// 			},
			// 			digits: '5678'
			// 		},
			// 		{
			// 			playType: {
			// 				id: 7,
			// 				name: 'Pick 5'
			// 			},
			// 			digits: '90123'
			// 		},
			// 	],
			// 	sortition: 'LUCKY LOTTO 12PM'
			// }
		};
	},
	methods: {
		handleResultsDone() {
			this.mode = modes.winningNumbers;

			setTimeout(() => {
				this.$root.$emit('sortition-time-done');
			}, 15000);
		}
	}
};
</script>

<style lang="scss" scoped></style>
